import cityPlaceholderImg from '@/../img/placeholders/city-placeholder.jpg';
import { PropertyPlatforms } from '@/widgets/components/property-platforms';
import { Header, PropertyCardImage } from '../property-card-styles';

interface Props {
  coverImageUrl: string;
  isContentHidden: boolean;
  onlinePlatforms: string[];
  printMode: boolean;
}

export function PresentationalPropertyCardHeader(props: Props) {
  const { isContentHidden, printMode, coverImageUrl, onlinePlatforms } = props;

  const imageSource = coverImageUrl || cityPlaceholderImg;
  const showListingPlatforms =
    Array.isArray(onlinePlatforms) && onlinePlatforms.length > 0;

  return (
    <Header printMode={printMode} data-cy="property-card-header">
      <div className="w-full h-full">
        {/* No aria-hidden attribute is used, as the listing platforms are overlaid on top of the property image. */}
        <PropertyCardImage
          alt={isContentHidden ? 'Placeholder property' : 'Property'}
          data-testid={
            isContentHidden
              ? 'property-card-placeholder-image'
              : 'property-card-image'
          }
          isContentHidden={isContentHidden}
          src={imageSource}
        />
      </div>

      {showListingPlatforms && (
        <PropertyPlatforms
          onlinePlatforms={onlinePlatforms}
          positions={{ top: '140px', right: '10px' }}
        />
      )}
    </Header>
  );
}
